export default "__VITE_ASSET__BjJgnv7___"